import { RemoteGetProfessionalOverview } from 'data/usecases';
import { GetProfessionalOverviewUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalOverview } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetProfessionalOverview =
  (): GetProfessionalOverviewUseCaseInterface =>
    new RemoteGetProfessionalOverview(
      makeApiUrlProfessionalOverview(),
      makeAxiosHttpClient(),
    );
